// extracted by mini-css-extract-plugin
export default {"CustomCheckbox":"CheckBoxStyle_CustomCheckbox__UavgB","CustomCheckbox_input":"CheckBoxStyle_CustomCheckbox_input__TD0oT"};